const selectcharacter = () => import('@/module/index/pages/select/character.vue')
export default {
  path: '/selectcharacter',
  component: selectcharacter,
  meta: {
    title: '',
    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    isback: false
  }
}



// WEBPACK FOOTER //
// ./src/publicResource/router/select.js